import useInterval from "components/hook/useInterval";
import { LIVEIMG_URL } from "constant/config";
import React, { useCallback, useMemo, useState } from "react";
import { isIE } from "react-device-detect";
import { Trans } from "react-i18next";

const LiveImage = ({ broad, refresh }) => {
    const { broad_grade, is_password, broad_no } = broad;
    let [delay, setDelay] = useState(refresh ? 10000 : null);
    const [imgError, setImgError] = useState(false);
    const defultBroadUrl = useMemo(() => {
        if (!isIE) {
            return `${LIVEIMG_URL}/h/${broad_no}.webp`;
        } else {
            return `${LIVEIMG_URL}/h/${broad_no}.jpg`;
        }
    }, [broad_no]);
    const [broadThumbnail, setBroadThumbnail] = useState(defultBroadUrl);

    useInterval(() => {
        setBroadThumbnail(`${defultBroadUrl}?${Math.random()}`);
    }, delay);

    const handleLiveImageError = useCallback((e) => {
        setImgError(true);
        setDelay(null);
    }, []);

    // 19금
    if (broad_grade === 19 && !is_password) {
        return (
            <span className="thumb-adult">
                <Trans>19vàng</Trans>
            </span>
        );
    }

    // 19금 + 비번방
    if (broad_grade === 19 && is_password) {
        return (
            <span className="thumb-lock_adult">
                <Trans>19vàng + Xúc phạm</Trans>
            </span>
        );
    }

    // 비번방
    if (broad_grade !== 19 && is_password) {
        return (
            <span className="thumb-lock">
                <Trans>Xúc phạm</Trans>
            </span>
        );
    }

    // default
    if (broad_grade !== 19 && !is_password) {
        if (imgError) {
            return (
                <span className="thumb-default">
                    <Trans>hình nhỏ</Trans>
                </span>
            );
        } else {
            return <img src={broadThumbnail} alt="" onError={handleLiveImageError} />;
        }
    }
};

export default LiveImage;
